import "suneditor/dist/css/suneditor.min.css";
import SunEditor from "suneditor-react";

function Editor({setContents,  onChange, readOnly = false }) {
  console.log("setContents",setContents);
  return (
    <SunEditor
    setContents={setContents}
      onChange={onChange}
      width="100%"
      height={200}
      setOptions={{
        buttonList: [
          ["undo", "redo", "font", "fontSize", "formatBlock"],
          [
            "bold",
            "underline",
            "italic",
            "strike",
            "subscript",
            "superscript",
            "removeFormat",
          ],
          ["fontColor", "hiliteColor"],
          [
            "dir",
            "outdent",
            "indent",
            "align",
            "horizontalRule",
            "list",
            "link",
          ],
        ],
        rtl: true,
        resizingBar: false,
      }}
      hideToolbar={readOnly}
      readOnly={readOnly}
      disable={readOnly}
    />
  );
}

export default Editor;
